export default "__VITE_ASSET__f118576c__"